"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gaiole-in-chianti": {
    "8ed58f4c": [{
      "hkey": "4cff0be0",
      "slug": "castagnoli-san-martino",
      "name": "Castagnoli-San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "castagnoli": [{
      "hkey": "4cff0be0",
      "slug": "castagnoli-san-martino",
      "name": "Castagnoli-San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4943e824": [{
      "hkey": "b9dbb3b2",
      "slug": "gaiole-in-chianti",
      "name": "Gaiole in Chianti",
      "primary": true,
      "skipSearch": false
    }],
    "monte-luco": [{
      "hkey": "b9dbb3b2",
      "slug": "gaiole-in-chianti",
      "name": "Gaiole in Chianti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1887c333": [{
      "hkey": "e5faf00f",
      "slug": "san-regolo-madonna-a-brolio",
      "name": "San Regolo-Madonna a Brolio",
      "primary": true,
      "skipSearch": false
    }],
    "regolo": [{
      "hkey": "e5faf00f",
      "slug": "san-regolo-madonna-a-brolio",
      "name": "San Regolo-Madonna a Brolio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;